import { CmsAlertPanel } from '@domgen/dgx-fe-cms';

export interface CmsIneligiblePage {
  pageTitle: string;
  ineligibleAlertPanel: CmsAlertPanel;
}
